module.exports = __webpack_public_path__ + "media/images/icons/twotone/file-text-9d7ada9485208f2d9e3f06f8711a9cb6.svg";